
/*
  return query object from query string
*/
export const stringToQuery = _string => {
  if (!_string) {
    return "";
  }
  let query = {},
    p = new URLSearchParams(_string);
  if (p.toString()) {
    p.forEach((val, key) => {
      query[key] = val;
    });
    return query;
  } else {
    return "";
  }
};

export const toDateObj = date => {
  if (date) {
    let validDateString;
    if (typeof date === "string") {
      let split = date.split("/");
      if (split.length) {
        // HOPEFULLY DD/MM/YYYY
        validDateString = `${split[2]}-${split[1]}-${split[0]}`;
      }
      return new Date(validDateString);
    }
    return new Date(date);
  }
  return null;
};

export const toDateNoTimezone = date => {
  let _date = new Date(date);
  if (_.isDate(_date)) {
    let tz = _date.getTimezoneOffset() * 60000;
    return new Date(_date.getTime() - tz).setHours(0, 0, 0, 0);
  }
  return null;
};

export const isIE = function() {
  var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
  var msie = ua.indexOf("MSIE "); // IE 10 or older
  var trident = ua.indexOf("Trident/"); //IE 11
  // console.log("ua > ", ua);
  return msie > 0 || trident > 0;
};

export const splitLines = function(startDelay,delayMultiplyer,splitElement,outerClass,innerClass)
{
  //split text to words
  var p = splitElement;
  //temp = temp.replace(/-/g, ' - '); //replace the hypen with space to avoid none breaking words 
  
  var p = splitElement;//document.getElementsByClassName('split-text')[0];
  p.innerHTML = p.innerText.split(/\s/).map(function(word) 
  {
    let wordSpan = '';
    let hypenIndex = word.indexOf("-");
    if(hypenIndex>-1)
    {
      //fix the hypen issue, 
      //in case of hypen in word we will split to more elements
      //'<span>some-word</span>' => <span>some</span><span>-</span><span>word</span>
      var hypernWordsArr = word.split("-");
      for (var ii = 0; ii < hypernWordsArr.length; ii++) {
        wordSpan = wordSpan + '<span>' + hypernWordsArr[ii] + '</span>';
        if(ii<hypernWordsArr.length-1){
          wordSpan = wordSpan + '<span>-</span>';
        }
      }      
    }else{
      wordSpan = '<span>' + word + '</span>';
    }
    return wordSpan;
  }).join(' ');  

  //get lines  
  var lines = [];
  var line;
  var words = p.getElementsByTagName('span');
  //console.log(">>>>>> words count ="+words.length);

  var lastTop;
  for (var i = 0; i < words.length; i++) {
    var word = words[i];
    let wOff = word.offsetTop;
    if (word.offsetTop != lastTop) 
    {
      lastTop = word.offsetTop;
      //console.log(">>>>>> lastTop="+lastTop);
      line = [];
      lines.push(line);
    }
    line.push(word);
  }

  var splittedText = "";
  //console.log(">>> lines.length="+lines.length);

  for (var lineIndex = 0; lineIndex < lines.length; lineIndex++) {
    var lineText = "";
    for (var wordIndex = 0; wordIndex < lines[lineIndex].length; wordIndex++) {
      lineText=lineText+lines[lineIndex][wordIndex].innerText+' ';
      lineText = lineText.replace(" - ", "-");
      lineText = lineText.replace("- ", "-");
      lineText = lineText.replace(" -", "-");
    }    

    let lineDelay = delayMultiplyer*lineIndex;
    splittedText = splittedText +
    "<div class='"+outerClass+"' style='--index:"+lineDelay+
    "'><div class='"+innerClass+
    "' style='--line_index:"+lineDelay+";--start_delay:"+startDelay+"'>"+lineText+"</div></div>";
  }
  p.innerHTML = splittedText;
}

export const splitLinesAndChars = function(startDelay,delayMultiplyer,splitElement,outerClass,innerClass)
{
  //split text to words

  var p = splitElement;
  let temp = p.innerHTML;
  temp = temp.replace(/-/g, ' - '); //replace the hypen with space to avoid none breaking words 
  
  //Split by spaces
  temp = temp.split(/\s/).map(function(word) {
    return '<span>' + word + '</span>'
  }).join(' ');

  p.innerHTML = temp;

  //get lines  
  var lines = [];
  var line;
  var words = p.getElementsByTagName('span');
  //console.log(">>>>>> words count ="+words.length);

  var lastTop;
  for (var i = 0; i < words.length; i++) {
    var word = words[i];

    let wOff = word.offsetTop;
    //console.log(">>>>>> wOff="+wOff);

    
    if (word.offsetTop != lastTop) 
    {
      lastTop = word.offsetTop;
      //console.log(">>>>>> lastTop="+lastTop);
      line = [];
      lines.push(line);
    }
    line.push(word);
  }

  var splittedText = "";
  console.log(">>> lines.length="+lines.length);

  for (var lineIndex = 0; lineIndex < lines.length; lineIndex++) {
    var lineText = "";
    for (var wordIndex = 0; wordIndex < lines[lineIndex].length; wordIndex++) {
      lineText=lineText+lines[lineIndex][wordIndex].innerText+' ';
    }    

    //break each line into chars spans 
    let lineChars = '';
    let cahrDelayIndex = 0;

    //lineIndex
    for (var charIndex = 0; charIndex < lineText.length; charIndex++) {
      let bzc = bezier(
        charIndex/100, // currentTime of the animation
        0, // initial Value
        1 * 0.46,
        0 * 0.46, 
       100 // final value
      );  
      let styleVars = "style='--bzc:"+bzc+";--line:"+lineIndex+";--char:"+charIndex + "'";
      lineChars = lineChars + "<span class='char' "+styleVars+" >" + lineText[charIndex] + "</span>";
    }
    lineText = lineChars;

    let lineDelay = delayMultiplyer*lineIndex;
    console.log("delayMultiplyer="+delayMultiplyer);//[0][0].innerText);
    splittedText = splittedText +
    "<div class='"+outerClass+"' style='--index:"+lineDelay+
    "'><div class='"+innerClass+
    "' style='--line_index:"+lineDelay+";--start_delay:"+startDelay+"'>"+lineText+"</div></div>";
  }
  p.innerHTML = splittedText;
}

function bezier(t, initial, p1, p2, final) {
  return (
    (1 - t) * (1 - t) * (1 - t) * initial +
    3 * (1 - t) * (1 - t) * t * p1 +
    3 * (1 - t) * t * t * p2 +
    t * t * t * final
  );
}

